export var isSpaceEdited = function (editTag, spaceNumber, openSpace) {
    var original = {
        title: editTag.title,
        openSpace: editTag.openSpace,
    };
    var edited = {
        title: spaceNumber,
        openSpace: openSpace,
    };
    return original !== edited;
};
export var isTableEdited = function (editTag, spaceNumber, tableLetter) {
    var original = {
        spaceNumber: editTag.space,
        tableLetter: editTag.letter,
    };
    var edited = {
        spaceNumber: spaceNumber,
        tableLetter: tableLetter,
    };
    return original !== edited;
};
export var getSpaceByTag = function (floor, spaceTag) {
    var index = floor.spaces.findIndex(function (space) {
        return space.title === spaceTag.title;
    });
    return index > -1 ? floor.spaces[index] : null;
};
export var getSpaceByTable = function (floor, table) {
    var index = floor.spaces.findIndex(function (space) {
        return space.title === table.space;
    });
    return index > -1 ? floor.spaces[index] : null;
};
export var getTableByTag = function (space, tableTag) {
    var index = space.tables.findIndex(function (table) {
        return table === tableTag;
    });
    return index > -1 ? space.tables[index] : null;
};
export var getTableByLetter = function (space, tableLetter) {
    if (tableLetter === '-') {
        return null;
    }
    var index = space.tables.findIndex(function (table) {
        return table.letter === tableLetter;
    });
    return index > -1 ? space.tables[index] : null;
};
export var getOwner = function (list, owner) {
    var index = list.findIndex(function (item) {
        return item === owner;
    });
    return index > -1 ? list[index] : null;
};
//# sourceMappingURL=mark-utils.js.map